var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mainChannelClient" } },
    [
      _c("CrearClienteModal", {
        attrs: { show: _vm.showCreateModal },
        on: { cerrar: _vm.handleCierreModalCrear }
      }),
      _c(
        "v-layout",
        { attrs: { wrap: "", column: "false" } },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "Ingrese el campo a buscar...",
                      "append-icon": "search"
                    },
                    on: {
                      input: function($event) {
                        return _vm.handleSearchField()
                      }
                    },
                    model: {
                      value: _vm.SearchFieldClient,
                      callback: function($$v) {
                        _vm.SearchFieldClient = $$v
                      },
                      expression: "SearchFieldClient"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { sm3: "", md3: "" } }),
              _c("v-flex", { attrs: { sm3: "", md3: "" } }),
              _c("v-flex", { attrs: { sm3: "", md3: "" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      display: "flex",
                      "justify-content": "flex-end"
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-crear",
                        staticStyle: { height: "47px" },
                        attrs: { color: "#ffe800" },
                        on: { click: _vm.handleClickCreate }
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { left: "", dark: "", icon: "" } },
                          [_vm._v("add")]
                        ),
                        _vm._v(" Crear Cliente\n          ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("GridComponent", {
            ref: "gridComponent",
            staticClass: "ag-theme-material",
            attrs: { id: "gridComponent", gridOptions: _vm.gridOptions }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }